import { UpdateNotifications } from '@app/finxone-web-frontend/app/lib/actions/notification.action';
import { NotificationModel } from '@app/finxone-web-frontend/app/lib/services/account-service/account.type';
import { NotificationState } from '@app/finxone-web-frontend/app/lib/state/notifications.state';
import {
  NotificationsStatusRequest,
  NotificationTransactionStatus,
  NotificationTypeEnum,
  PaginationMeta,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable, of, Subject } from 'rxjs';

export class MockNotificationService {
  constructor(private store: Store) {}
  private _notificationListSubject: Subject<NotificationModel[]> = new Subject<NotificationModel[]>();
  private now = new Date();
  private oneMinuteAgo = new Date(this.now.getTime() - 1 * 60 * 1000);
  private thirtyMinutesAgo = new Date(this.now.getTime() - 30 * 60 * 1000);
  private threeHoursAgo = new Date(this.now.getTime() - 3 * 60 * 60 * 1000);
  private yesterday = new Date(this.now.getTime() - 24 * 60 * 60 * 1000);
  private threeDaysAgo = new Date(this.now.getTime() - 3 * 24 * 60 * 60 * 1000);
  private novuServiceInitialised = true;

  private _notificationList: NotificationModel[] = [
    {
      notificationId: '659ffd036887395d606fd8a5',
      novuId: '5',
      url: 'http://localhost:4200/zones/payments/landing/456',
      content: 'Your payment request has been approved.',
      createdAt: this.now.toISOString(), // Just now
      seen: false,
      read: false,
      txnId: '',
      payload: {
        amount: '£500',
        transactionId: '456',
        paymentId: '22222',
        status: NotificationTransactionStatus.SUCCESS,
        notificationType: NotificationTypeEnum.TRANSACTION_INCOMING,
        inAppTitle: 'Your payment request has been approved.',
        inAppDescription: 'Payment approved and processed successfully',
      },
    },
    {
      notificationId: '65a0117e3ea702c7522a23a8',
      novuId: '',
      url: 'http://localhost:4200/zones/payments/landing/123',
      seen: true,
      read: true,
      content: 'Your outbound transfer of £1000 has been processed successfully.',
      createdAt: this.oneMinuteAgo.toISOString(), // 1 minute ago
      txnId: '',
      payload: {
        amount: '£1000',
        transactionId: '123',
        paymentId: '11111',
        status: NotificationTransactionStatus.SUCCESS,
        notificationType: NotificationTypeEnum.TRANSACTION_OUTGOING,
        inAppTitle: 'Your outbound transfer of £1000 has been processed successfully.',
        inAppDescription: 'You paid Alex Dale £1000 at 11:28 on 11 January 2024',
      },
    },
    {
      notificationId: '659ffe2b26c83f6e6f30e258',
      novuId: '2',
      url: 'http://localhost:4200/zones/payments/landing/11111',
      seen: false,
      read: false,
      content: 'Your outbound transfer of £233443 has been processed successfully.',
      createdAt: this.thirtyMinutesAgo.toISOString(), // 30 minutes ago
      txnId: '',
      payload: {
        amount: '£233443',
        transactionId: '11111',
        paymentId: '11111',
        status: NotificationTransactionStatus.SUCCESS,
        notificationType: NotificationTypeEnum.TRANSACTION_OUTGOING,
        inAppTitle: 'Your outbound transfer of £233443 has been processed successfully.',
        inAppDescription: 'You paid Alex Dale £233443 at 11:28 on 11 January 2024',
      },
    },
    {
      notificationId: '659ffe1ddb8c73fea23bfc24',
      novuId: '3',
      url: 'http://localhost:4200/zones/profile/notification-balance',
      seen: true,
      read: true,
      content: 'Hi James, Your daily balance update GBP 1467',
      createdAt: this.threeHoursAgo.toISOString(), // 3 hours ago
      txnId: '',
      payload: {
        currency: 'GBP',
        amount: '1467',
        notificationType: NotificationTypeEnum.DAILY_BALANCE,
        inAppTitle: '',
        inAppDescription: '',
      },
    },
    {
      notificationId: '659ffd036887395d606fd8a4',
      novuId: '4',
      url: 'http://localhost:4200/zones/payments/landing/123',
      seen: true,
      read: true,
      content: 'Your inbound transfer of £1000 has been processed successfully.',
      createdAt: this.yesterday.toISOString(), // Yesterday
      txnId: '',
      payload: {
        amount: '£1000',
        transactionId: '123',
        paymentId: '11111',
        status: NotificationTransactionStatus.SUCCESS,
        notificationType: NotificationTypeEnum.TRANSACTION_INCOMING,
        inAppTitle: 'Your inbound transfer of £1000 has been processed successfully.',
        inAppDescription: 'You received £1000 from Alex Dale at 11:28 on 11 January 2024',
      },
    },
    {
      notificationId: '659ffd036887395d606fd8a6',
      novuId: '6',
      url: 'http://localhost:4200/zones/payments/landing/789',
      seen: false,
      read: false,
      content: 'Monthly statement is now available.',
      createdAt: this.threeDaysAgo.toISOString(), // 3 days ago
      txnId: '',
      payload: {
        notificationType: NotificationTypeEnum.DAILY_BALANCE,
        inAppTitle: 'Monthly statement is now available.',
        inAppDescription: 'Your monthly statement for May 2025 is ready to view',
      },
    },
  ] as NotificationModel[];

  public getNotificationList(): Subject<NotificationModel[]> {
    this.store.dispatch(new UpdateNotifications(this._notificationList, false, {} as PaginationMeta));
    return this._notificationListSubject;
  }

  public callNovuServiceToFetchNotifications(_page: string, _limit: string, _filterType: string) {
    return Promise.resolve({
      data: {
        notifications: this._notificationList,
        hasMore: false,
      },
    });
    // empty mock
  }

  public unreadNotificationsCount$(): Observable<number> {
    return of(this._notificationList.filter((notification) => !notification.read).length);
  }

  public getNotificationState() {
    return this.store.select(NotificationState.getNotification);
  }

  public updateNotificationStatus(payload: NotificationsStatusRequest) {
    return of('');
  }

  public fetchNotificationPayloadData(payload: { feedIdentifierIds: string[] }) {
    return of([]);
  }
}
